// extracted by mini-css-extract-plugin
export default {"link":"FL-z","disabled":"GL-z"};